<template>
	<div>
		<router-view></router-view>
		<dialogs-wrapper transition-name="modal"></dialogs-wrapper>
		<vue-progress-bar></vue-progress-bar>
	</div>
</template>

<script>

export default {
	// components: {FileUploader},
	// extends: BaseComponent,
	name: 'App',

}
</script>

